import { useState } from 'react';
import { Button } from '@mui/material';
import AboutModal from 'src/Components/AboutModal';
import Box from '@mui/material/Box';

import auriaLogo from "../assets/img/AURIA_LOGO_WHITE+COLOR_64.png";

type Props = { 
  error?: string,
  message?: string,
  showAbout?: boolean,
};

function Footer(props: Props) {

  const [isAboutOpen, setIsAboutOpen] = useState(false);
  
  const toggleAbout = () => {
    setIsAboutOpen(!isAboutOpen);
  }

  return (
    <footer>
      <Box className="copyright-footer" sx={{ flexShrink: 0 }}>
        <a href="https://www.auria.space/" target="_blank" rel="noreferrer"><img alt="Auria, LLC Logo" src={auriaLogo} /></a>
        <div className="copyright">© 2026 Boecore, LLC doing business as Auria</div>
        {props.showAbout ?? (<Button
            id="button-about"
            sx={{
              border: '2px solid',
              borderColor: 'rgba(87,236,243,1)',
              color: 'rgba(87,236,243,1)',
              fontWeight: 'bold',
              borderRadius: '4px',
              fontSize: '0.875rem',
              '&:hover': {
                borderColor: 'orange',
                color: 'orange',
                backgroundColor: 'transparent'
              },
            }}
            onClick={toggleAbout}
          >
          About
          </Button>)}
      </Box>
      <AboutModal isOpen={isAboutOpen} onClose={toggleAbout} />
    </footer>
  );  
}

export default Footer;